import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-confirm-logout-dialog',
  templateUrl: './confirm-logout-dialog.component.html',
  styleUrls: ['./confirm-logout-dialog.component.scss']
})
export class ConfirmLogoutDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
